import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ResultInfoGenericDto } from '../dto/ResultInfoDto';

@Injectable({
	providedIn: 'root'
})
export class FileDownloadService {

	private apiDownloadPdf: string = "api/Download/PdfGui/";

	constructor(private http: HttpClient) { }

	downloadZadostPdf(id: number, token: string): Observable<ResultInfoGenericDto<any>> {
		let url = this.apiDownloadPdf + id + "?t=" + token;
		return this.http.get<ResultInfoGenericDto<any>>(url)
			.pipe(
				tap((res: ResultInfoGenericDto<any>) => {
					try {
						if (res.success) {
							const source = `data:application/pdf;base64,${res.data}`;
							let link = document.createElement("a");
							link.href = source;
							link.download = `${id}.pdf`
							link.click();
						}
						return res;
					} catch (ex) {
						console.error(ex);
						var res = new ResultInfoGenericDto<any>();
						res = { data: null, messages: ["Neočekávaná chyba"], success: false }
						return res;
					}
				})
			);
	}
}
